module.exports = __webpack_public_path__ + "media/news/close_icon-017ea46f.svg";